import { Intent } from "../intent/Intent.js";
import { RouterModule } from "./RouterModule.js";
import { RouterMetadataKey } from "../decorators/route/Router.js";
import { SimAtomic } from "../simstance/SimAtomic.js";
import { Expression } from "@dooboostore/core";
import { RouterAction } from "../route/RouterAction.js";
import { Subject } from "@dooboostore/core";
class RouterManager {
  constructor(simpleApplication, simstanceManager, simOption) {
    this.simpleApplication = simpleApplication;
    this.simstanceManager = simstanceManager;
    this.simOption = simOption;
    this.subject = new Subject();
  }
  // @SimNoProxy
  get observable() {
    return this.subject.asObservable();
  }
  routingMap(option) {
    const targetRouter = option?.router ?? this.simOption.rootRouter;
    if (!targetRouter) {
      throw new Error("no router");
    }
    const map = {};
    if (targetRouter) {
      const targetType = typeof targetRouter === "object" ? targetRouter.constructor : targetRouter;
      const targetValue = typeof targetRouter === "object" ? targetRouter : void 0;
      const routerAtomic = new SimAtomic({ targetKeyType: targetType, originalType: targetType, value: targetValue }, this.simstanceManager);
      const routerData = routerAtomic.getConfig(RouterMetadataKey);
      if (routerData) {
        const currentPrefix = (option?.prefix ?? "") + routerData.path;
        if (routerData.route && routerData.route[""]) {
          map[currentPrefix] = routerData.route[""];
        }
        if (routerData.route) {
          Object.entries(routerData.route).forEach(([key, value]) => {
            map[currentPrefix + key] = value;
          });
        }
        routerData.routers?.forEach((it) => {
          Object.assign(map, this.routingMap({ ...option, router: it, prefix: currentPrefix }));
        });
      }
    }
    return map;
  }
  /** 일반적인 lifecycle 타지않는 그냥 find.. 의미가없을듯.
   * @deprecated
   */
  async routings(intent, option) {
    const targetRouter = option?.router ?? this.simOption.rootRouter;
    if (!targetRouter) {
      throw new Error("no router");
    }
    const targetType = typeof targetRouter === "object" ? targetRouter.constructor : targetRouter;
    const targetValue = typeof targetRouter === "object" ? targetRouter : void 0;
    const routerAtomic = new SimAtomic({ targetKeyType: targetType, originalType: targetType, value: targetValue }, this.simstanceManager);
    const allMatches = this._collectAllMatchingModules(routerAtomic, intent, []);
    const exactModuleMatches = allMatches.filter((rm) => rm.path === intent.pathname && rm.module);
    if (exactModuleMatches.length > 0) {
      exactModuleMatches.forEach((it) => this.subject.next({ intent, routerManager: this, routerModule: it }));
      return exactModuleMatches;
    }
    const exactPathMatches = allMatches.filter((rm) => rm.path === intent.pathname);
    if (exactPathMatches.length > 0) {
      exactPathMatches.forEach((it) => this.subject.next({ intent, routerManager: this, routerModule: it }));
      return exactPathMatches;
    }
    return [];
  }
  async routing(intent, option) {
    if (typeof intent === "string") {
      intent = new Intent(intent);
    }
    const targetRouter = option?.router ?? this.simOption.rootRouter;
    const callCheckOnRouting = option?.noOnRouting !== true;
    if (!targetRouter) {
      throw new Error("no router");
    }
    const targetType = typeof targetRouter === "object" ? targetRouter.constructor : targetRouter;
    const targetValue = typeof targetRouter === "object" ? targetRouter : void 0;
    const routerAtomic = typeof targetType === "symbol" ? this.simstanceManager.findFirstSim(targetType) : new SimAtomic({ targetKeyType: targetType, originalType: targetType, value: targetValue }, this.simstanceManager);
    const rootRouter = routerAtomic.getValue();
    const executeModuleResult = this.getExecuteModule(routerAtomic, intent, [], option);
    if (executeModuleResult) {
      const [executeModule, routerChains] = executeModuleResult;
      executeModule.routerChains = routerChains;
      this.activeRouterModule = executeModule;
      const routingDataSet = { intent, routerModule: executeModule, routerManager: this };
      if (routerChains.length > 0) {
        for (let i = 0; i < routerChains.length; i++) {
          const current = routerChains[i];
          const next = routerChains[i + 1];
          const value = current.getValue();
          if (RouterAction.isCanActivate(value) && next) {
            await value.canActivate(routingDataSet, next.getValue());
          }
          if (callCheckOnRouting && RouterAction.isOnRouting(value) && next) {
            await value.onRouting(routingDataSet);
          }
        }
      }
      this.activeRouterModule = executeModule;
      const moduleInstance = executeModule.getModuleInstance();
      if (!executeModule?.module) {
        const routerChain = executeModule.routerChains[executeModule.routerChains.length - 1];
        const value = routerChain?.getValue();
        if (RouterAction.isCanActivate(value)) {
          await value.canActivate(routingDataSet, moduleInstance);
        }
        if (callCheckOnRouting && RouterAction.isOnRouting(value)) {
          await value.onRouting(routingDataSet);
        }
      } else {
        const value = executeModule.router?.getValue();
        if (RouterAction.isCanActivate(value)) {
          await value.canActivate(routingDataSet, moduleInstance);
        }
        if (callCheckOnRouting && RouterAction.isOnRouting(value)) {
          await value.onRouting(routingDataSet);
        }
        if (moduleInstance && callCheckOnRouting && RouterAction.isOnRouting(moduleInstance)) {
          await moduleInstance.onRouting(routingDataSet);
        }
      }
      const find = this.activeRouterModule;
      this.subject.next({ intent, routerModule: find, routerManager: this });
      return find;
    } else {
      const empty = await this._handleNotFoundRouting(rootRouter, intent);
      this.subject.next({ intent, routerModule: empty, routerManager: this });
      return empty;
    }
  }
  /**
   * URL과 일치하는 라우트를 찾지 못했을 경우를 처리합니다.
   * "Not Found" 상태를 나타내는 비어있는 RouterModule 객체를 생성하여 반환합니다.
   * 이 과정에서 rootRouter의 라이프사이클을 호출하여 공통 레이아웃등을 처리할 수 있습니다.
   * @param rootRouter 앱의 최상위 라우터 인스턴스
   * @param intent 확인에 실패한 원본 Intent 객체
   * @private
   */
  async _handleNotFoundRouting(rootRouter, intent) {
    const routerModule = new RouterModule(this.simstanceManager, rootRouter, void 0, []);
    const routingDataSet = { intent, routerModule, routerManager: this };
    const value = rootRouter;
    if (RouterAction.isCanActivate(value)) {
      await value.canActivate(routingDataSet, null);
    }
    if (RouterAction.isOnRouting(value)) {
      await value.onRouting(routingDataSet);
    }
    this.activeRouterModule = routerModule;
    return this.activeRouterModule;
  }
  getExecuteModule(router, intent, parentRouters, option) {
    const path = intent.pathname;
    const routerConfig = router.getConfig(RouterMetadataKey);
    if (routerConfig) {
      const filters = [];
      if (Array.isArray(routerConfig.filters)) {
        filters.push(...routerConfig.filters);
      } else if (routerConfig.filters) {
        filters.push(routerConfig.filters);
      }
      const noAccept = filters.some((it) => (typeof it === "function" ? this.simstanceManager.getOrNewSim({ target: it }) : it)?.isAccept(intent) === false);
      if (noAccept) {
        return;
      }
      const routerStrings = parentRouters.map((it) => it.getConfig(RouterMetadataKey)?.path || "");
      const isRoot = this.isRootUrl(routerConfig.path, routerStrings, path);
      if (isRoot) {
        const currentParentRouters = [...parentRouters, router];
        if (routerConfig.routers && routerConfig.routers.length > 0) {
          let bestMatchModule = void 0;
          let bestMatchLength = -1;
          for (const child of routerConfig.routers) {
            const routerAtomic = typeof child === "symbol" ? this.simstanceManager.findFirstSim(child) : new SimAtomic({ targetKeyType: child, originalType: child }, this.simstanceManager);
            if (!routerAtomic) {
              continue;
            }
            const executeModule = this.getExecuteModule(routerAtomic, intent, currentParentRouters, option);
            if (executeModule) {
              const [rm, chains] = executeModule;
              const currentMatchLength = rm.path?.length || 0;
              if (currentMatchLength > bestMatchLength) {
                bestMatchLength = currentMatchLength;
                bestMatchModule = executeModule;
              } else if (currentMatchLength === bestMatchLength) {
                if (option?.find?.router === "last") {
                  bestMatchModule = executeModule;
                }
              }
            }
          }
          if (bestMatchModule) {
            return bestMatchModule;
          }
        }
        const module = this.findRouterOrModule(router, routerConfig, routerStrings, intent);
        if (module) {
          return [module, currentParentRouters];
        }
      }
    }
  }
  // path: 지금 내 라우터의 path,  parentRoots: 부모router path들,  url: 사용자가 원하는 full intent url
  isRootUrl(path, parentRoots, url) {
    const searchString = parentRoots.join("") + (path || "");
    if (searchString === "/") {
      return true;
    }
    const searchs = searchString.split("/");
    const urls = url.split("/");
    const trimmedUrls = urls.slice(0, searchs.length).join("/");
    return !!Expression.Path.pathNameData(trimmedUrls, searchString);
  }
  _collectAllMatchingModules(router, intent, parentRouters) {
    const matches = [];
    const path = intent.pathname;
    const routerConfig = router.getConfig(RouterMetadataKey);
    if (routerConfig) {
      const filters = [];
      if (Array.isArray(routerConfig.filters)) {
        filters.push(...routerConfig.filters);
      } else if (routerConfig.filters) {
        filters.push(routerConfig.filters);
      }
      const noAccept = filters.some((it) => (typeof it === "function" ? this.simstanceManager.getOrNewSim({ target: it }) : it)?.isAccept(intent) === false);
      if (noAccept) {
        return matches;
      }
      const routerStrings = parentRouters.map((it) => it.getConfig(RouterMetadataKey)?.path || "");
      const isRoot = this.isRootUrl(routerConfig.path, routerStrings, path);
      if (isRoot) {
        const currentParentRouters = [...parentRouters, router];
        if (routerConfig.routers && routerConfig.routers.length > 0) {
          for (const child of routerConfig.routers) {
            const routerAtomic = typeof child === "symbol" ? this.simstanceManager.findFirstSim(child) : new SimAtomic({ targetKeyType: child, originalType: child }, this.simstanceManager);
            if (!routerAtomic) {
              continue;
            }
            matches.push(...this._collectAllMatchingModules(routerAtomic, intent, currentParentRouters));
          }
        }
        const module = this.findRouterOrModule(router, routerConfig, routerStrings, intent);
        if (module) {
          module.routerChains = currentParentRouters;
          matches.push(module);
        }
      }
    }
    return matches;
  }
  findRouterOrModule(router, routerData, parentRoots, intent) {
    const module = this.findRouting(router, routerData, parentRoots, intent);
    if (module?.module) {
      module.intent = intent;
      return module;
    }
    const urlRoot = parentRoots.join("") + (routerData.path || "");
    if (this.isRootUrl(routerData.path, parentRoots, intent.pathname)) {
      const rm = new RouterModule(this.simstanceManager, router);
      rm.intent = intent;
      rm.path = urlRoot;
      rm.pathData = intent.getPathnameData(urlRoot);
      return rm;
    }
    return void 0;
  }
  findRouting(router, routerData, parentRoots, intent) {
    const urlRoot = parentRoots.join("") + routerData.path;
    if (routerData.route) {
      for (const it of Object.keys(routerData.route).filter((it2) => !it2.startsWith("_"))) {
        const path = urlRoot + it;
        const pathnameData = intent.getPathnameData(path);
        if (pathnameData) {
          try {
            const dataSet = this.findRouteProperty(routerData.route, it, intent);
            const rm = new RouterModule(this.simstanceManager, router, dataSet.child);
            rm.data = dataSet.data;
            rm.path = path;
            rm.pathData = pathnameData;
            rm.propertyKeys = dataSet.propertyKeys;
            return rm;
          } catch (e) {
          }
        }
      }
    }
  }
  findRouteProperty(route, propertyName, intent) {
    let child;
    let data;
    let propertyKeys;
    const routeElement = route[propertyName];
    if (typeof routeElement === "function") {
      child = { targetKeyType: routeElement, originalType: routeElement };
    } else if (typeof routeElement === "symbol") {
      const findSimType = this.simstanceManager.findLastSim(routeElement)?.type;
      if (findSimType?.originalType) {
        child = { targetKeyType: findSimType.originalType, originalType: findSimType.originalType };
      }
    } else if (typeof routeElement === "string") {
      return this.findRouteProperty(route, routeElement, intent);
    } else if (Array.isArray(routeElement)) {
      const r = routeElement?.[0];
      if (typeof r === "object" && "filters" in r && "target" in r) {
        const filters = [];
        if (Array.isArray(r.filters)) {
          filters.push(...r.filters);
        } else if (r.filters) {
          filters.push(r.filters);
        }
        const noAccept = filters.some((it) => (typeof it === "function" ? this.simstanceManager.getOrNewSim({ target: it }) : it)?.isAccept(intent) === false);
        if (!noAccept) {
          child = { targetKeyType: r.target, originalType: r.target };
        }
      } else {
        child = { targetKeyType: r, originalType: r };
      }
      data = routeElement?.[1];
    } else if (typeof routeElement === "object" && "target" in routeElement && "propertyKeys" in routeElement) {
      const noAccept = routeElement.filters?.filter((it) => it).some((it) => (typeof it === "function" ? this.simstanceManager.getOrNewSim({ target: it }) : it)?.isAccept(intent) === false);
      if (!noAccept) {
        child = { targetKeyType: routeElement.target, originalType: routeElement.target };
        propertyKeys = routeElement.propertyKeys;
      }
    } else if (typeof routeElement === "object" && "filters" in routeElement && "target" in routeElement) {
      const filters = [];
      if (Array.isArray(routeElement.filters)) {
        filters.push(...routeElement.filters);
      } else if (routeElement.filters) {
        filters.push(routeElement.filters);
      }
      const noAccept = filters.some((it) => (typeof it === "function" ? this.simstanceManager.getOrNewSim({ target: it }) : it)?.isAccept(intent) === false);
      if (!noAccept) {
        child = { targetKeyType: routeElement.target, originalType: routeElement.target };
      }
    }
    return {
      child,
      data,
      propertyKeys
    };
  }
}
export {
  RouterManager
};
//# sourceMappingURL=RouterManager.js.map
